import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getToken } from "../utils/auth";

const UnprotectedRoute: React.FC = () => {
  const locationTo = "/";

  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(() => {
    return !!getToken();
  });

  useEffect(() => {
    const syncAuth = () => {
      const tokenExists = !!getToken();
      setIsAuthenticated((prev) => (prev !== tokenExists ? tokenExists : prev));
    };

    const intervalCheck = setInterval(syncAuth, 1000);
    window.addEventListener("visibilitychange", syncAuth);
    window.addEventListener("focus", syncAuth);

    return () => {
      clearInterval(intervalCheck);
      window.removeEventListener("visibilitychange", syncAuth);
      window.removeEventListener("focus", syncAuth);
    };
  }, []);

  return !isAuthenticated ? <Outlet /> : <Navigate to={locationTo} replace />;
};

export default UnprotectedRoute;


// import React, { useEffect, useState } from "react";
// import { Outlet, useNavigate } from "react-router-dom";
// import { getToken } from "../utils/auth";
// import { useLazyGetProfileQuery } from "../services/admin/admin.rtk.api";
// import { adminRoutes } from "../routers/AdminRouters";

// const UnprotectedRoute: React.FC = () => {
//   const [getProfile] = useLazyGetProfileQuery();
//   const navigate = useNavigate();

//   const [isAuthenticated, setIsAuthenticated] = useState<boolean>(() => {
//     return !!getToken();
//   });

//   useEffect(() => {
//     const checkRoleAndRedirect = async () => {
//       if (isAuthenticated) {
//         try {
//           const profileRes = await getProfile().unwrap();
//           const role = (profileRes.result as any)?.role || (profileRes.result as any)?.user?.role;

//           if (role === 'Admin') {
//             navigate(adminRoutes.organisationList, { replace: true });
//           } else {
//             navigate(adminRoutes.adminList, { replace: true });
//           }
//         } catch (error: any) {
//           navigate(adminRoutes.dashboard, { replace: true });
//         }
//       }
//     };

//     if (isAuthenticated) {
//       checkRoleAndRedirect();
//     }

//     const syncAuth = () => {
//       const tokenExists = !!getToken();
//       // console.log("UnprotectedRoute: syncAuth token exists:", tokenExists);
//       setIsAuthenticated((prev) => {
//         if (prev !== tokenExists) {
//           return tokenExists;
//         }
//         return prev;
//       });
//     };

//     const intervalCheck = setInterval(syncAuth, 1000);
//     window.addEventListener("visibilitychange", syncAuth);
//     window.addEventListener("focus", syncAuth);

//     return () => {
//       clearInterval(intervalCheck);
//       window.removeEventListener("visibilitychange", syncAuth);
//       window.removeEventListener("focus", syncAuth);
//     };
//   }, [isAuthenticated, getProfile, navigate]);

//   if (isAuthenticated) {
//     return <div className="flex items-center justify-center min-h-screen">Loading...</div>;
//   }

//   return <Outlet />;
// };

// export default UnprotectedRoute;
